import { Component } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Component({
    selector: "four-o-four",
    imports: [],
    templateUrl: "404portable.component.html"
})
export class Portable404Component {
    private static readonly lostIds: string[] = [
        "01902d55-6b0a-7779-be96-0d6c4e6a22a7",
        "019030e8-23e3-7789-b349-34c8060d3951",
        "01902f31-96b5-74d9-988b-44b9ed5329a5",
        "01902d88-187e-7f9a-9594-da4db809772e",
        "01902ab9-4655-7639-a919-315a4082dcbc",
        "01903110-6f95-7266-a543-43f054106694",
        "01902de5-c471-77ae-8237-a73c7c4cc3ba",
        "019029c1-77ef-7771-a48f-75e438d36882",
        "01902baf-ebf5-7ebc-87ae-14ccf95bc336",
        "019030bd-f7bf-7a62-89e0-efce0794957a",
        "0190283c-619a-75db-a2af-80e55becac93",
        "01902f72-ccfe-72f6-aedc-73d329b04515",
        "01902a16-c49d-7462-bd01-9cfdee6737ed",
        "01902f50-93cb-7744-8c3b-6a09e1a2422a",
        "01902fcb-4039-7ab8-85cc-a65a93d098d0",
        "01902ba5-db4d-7846-a910-5a8c2820bd65",
        "019030fd-03cd-70a0-8c3c-013082e5202e",
        "019030cc-57ca-7cdd-93e8-8cebefc7335f",
        "01902d52-7706-7ddb-a32d-73e08fcd617e",
        "01903073-8a70-7d3b-bc8c-8795d3414ff0",
        "01902d16-2e3d-7a35-8813-849b988d2460",
        "01902dec-21a0-7662-9c82-be9c9ac6e294"
    ];

    public readonly lostImageId = Portable404Component.lostIds[Math.floor(Math.random() * Portable404Component.lostIds.length)];
    public readonly lostImageUrl = `${environment.ponderImageBaseUrl}/card/large/front/${this.lostImageId}.jpg`;

    public constructor() {
        
    }
}